/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'webcam': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.5 24.096a1.596 1.596 0 1 1 0-3.192 1.596 1.596 0 0 1 0 3.192zm6.017 7.546c-.454-.311-1.275-.565-1.825-.565h-2.209l.43-1.163c3.658-1.053 6.346-4.423 6.346-8.414 0-4.661-3.912-8.473-8.51-8.734v5.941c1.883.248 3.594 1.844 3.594 3.793s-1.711 3.545-3.594 3.793V30h-.5v-3.707c-1.883-.248-3.594-1.844-3.594-3.793s1.711-3.545 3.594-3.793v-5.941c-4.598.262-8.51 4.073-8.51 8.734 0 3.991 2.688 7.361 6.346 8.414l.43 1.163h-2.209c-.55 0-1.371.254-1.825.565l-1.158.793a.995.995 0 0 0-.255 1.387s1.457 2.101 7.43 2.101 7.43-2.101 7.43-2.101a.996.996 0 0 0-.255-1.387l-1.156-.793z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/webcam.js